import { useAtomValue } from "jotai";
import { queriesEnabledAtom } from "../../../atoms/GlobalAtoms";
import PageAPI from "../../api/PageAPI";
import { useQuery } from "@tanstack/react-query";
import { getErrorMessage } from "../../../utils/GeneralUtils";
import { View } from "../../../types/PageInterfaces";
import { workspaceIdAtom } from "../../../atoms/WorkspaceAtoms";

const useView = ({
  pageID,
  viewID,
  disabled = false,
}: {
  pageID: string | undefined;
  viewID: string | undefined;
  disabled?: boolean;
}) => {
  const workspaceID = useAtomValue(workspaceIdAtom);
  const queriesEnabled = useAtomValue(queriesEnabledAtom);

  const view = useQuery({
    queryKey: ["view", viewID],
    queryFn: () =>
      PageAPI.getViewByID(workspaceID, pageID, viewID).then(
        (data) => data.data.data.view || null
      ),
    enabled: !!viewID && viewID !== "None" && queriesEnabled && !disabled,
    structuralSharing: false, // Fixes bug with adding Calendars to Calendar view, then setting a record to use new calendar
    staleTime: Infinity, // Fixes refetch bugs caused by having StructuralSharing off
  });

  return {
    view: view.data as View | null,
    viewLoading: !queriesEnabled || disabled || view.isLoading,
    viewError: view.error ? getErrorMessage(view.error) : null,
  };
};

export default useView;
